/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { timesheetDocumentSummaryDtoSchema } from './timesheetDocumentSummaryDtoSchema.ts';
import { z } from 'zod';

export const activityFormDtoSchema = z.object({
  id: z.coerce.number().int(),
  customerId: z.coerce.number().int(),
  customerName: z.coerce.string(),
  description: z.coerce.string().nullable(),
  projectId: z.coerce.number().int().nullable(),
  projectName: z.coerce.string().nullable(),
  fromTime: z.string().datetime({ local: true }),
  toTime: z.string().datetime({ local: true }),
  effectiveHours: z.coerce.number(),
  km: z.coerce.number().nullable(),
  extraCosts: z.coerce.number().nullable(),
  costsDescription: z.coerce.string().nullable(),
  employeeId: z.coerce.number().int(),
  employeeName: z.coerce.string(),
  documents: z.array(z.lazy(() => timesheetDocumentSummaryDtoSchema)),
});
